import React from 'react'

export function MessagesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M2 4.25A1.75 1.75 0 00.25 6v10A1.75 1.75 0 002 17.75h11.25v2.5l3.5-2.5H22A1.75 1.75 0 0023.75 16V6A1.75 1.75 0 0022 4.25H2zM1.75 6A.25.25 0 012 5.75h20a.25.25 0 01.25.25v10a.25.25 0 01-.25.25h-5.73l-1.52 1.09v-1.09H2a.25.25 0 01-.25-.25V6z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M5 8.75a.75.75 0 000 1.5h14a.75.75 0 000-1.5H5zM5 11.75a.75.75 0 000 1.5h9a.75.75 0 000-1.5H5z"
      />
    </svg>
  )
}
